"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryLogger = void 0;
class SentryLogger {
    constructor(captureMessage) {
        this.captureMessage = captureMessage;
    }
    debug() {
        /**/
    }
    log() {
        /**/
    }
    info() {
        /**/
    }
    warn(...anything) {
        // special handling to group warnings
        // .. starting with a string, followed by additional arguments
        if (typeof anything[0] === 'string' && anything.length >= 2) {
            const message = anything.shift();
            const warningInfos = {};
            anything.forEach((a, idx) => {
                warningInfos[`arg${idx}`] = a;
            });
            // add the 'extra' here, to avoid setting it globally!
            this.captureMessage(message, { level: 'warning', extra: warningInfos });
            return;
        }
        // general handling, try to stringify whatever comes in and join it!
        const summedUpWarningMessage = anything.map((a) => this.unknownToString(a)).join(' ');
        this.captureMessage(summedUpWarningMessage, 'warning');
    }
    unknownToString(u) {
        if (typeof u === 'string')
            return u;
        if (typeof u === 'object' || Array.isArray(u)) {
            try {
                return JSON.stringify(u);
            }
            catch (_a) {
                /**/
            }
        }
        return String(u);
    }
    error() {
        /**/
    }
}
exports.SentryLogger = SentryLogger;
//# sourceMappingURL=sentry-logger.js.map